import React, { useEffect, useState, useCallback } from 'react';
import { checkBackend, BackendStatus } from '../../utils/checkBackend';

function Test() {
    const [backendAlive, setBackendAlive] = useState(null);
    const [sum, setSum] = useState(null);

    const handleCheckBackend = useCallback(() => {
        checkBackend(setBackendAlive);
    }, []);

  useEffect(() => {
    handleCheckBackend();
    // 例: 5秒ごとに自動チェックしたい場合は下記コメントアウトを外す
    // const intervalId = setInterval(handleCheckBackend, 5000);
    // return () => clearInterval(intervalId);
  }, [handleCheckBackend]);

  const sendBackend = async () => {
    const inputA = document.getElementById('inputA').value;
    const inputB = document.getElementById('inputB').value;
    //バックエンドにa,bを送信して、合計を取得し、sumにセット
    try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
        const response = await fetch(`${apiUrl}/test`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ a: inputA, b: inputB })
        });

        if (response.ok) {
            const data = await response.json();
            setSum(data.sum);
        } else {
            console.error('Error fetching sum:', response.statusText);
        }
    } catch (error) {
        console.error('Error fetching sum:', error);
    }
  };


  return (
        <div className="page">
            <h1 className="heading-hero mb-4">Test Page</h1>
            <div className="card">
                <form className="form-group">
                    <input
                        type="number"
                        placeholder="Aの値"
                        id="inputA"
                        name="inputA"
                        className="form-input"
                    />
                    <input
                        type="number"
                        placeholder="Bの値"
                        id="inputB"
                        name="inputB"
                        className="form-input"
                    />
                    <div className="row-center">
                        <button
                            type="button"
                            onClick={sendBackend}
                            className="btn btn--primary"
                        >
                            Click Me
                        </button>
                    </div>
                </form>
                <p className="heading-lg text-center">{sum}</p>
                <BackendStatus backendAlive={backendAlive} onCheck={handleCheckBackend} />
            </div>
        </div>
    );
}

export default Test;